import React from 'react'

const Fifteen = () => {
    return (
        <div className='container'>
            <h1>How to write main function in Different ways?</h1>
            <h3>Main can be written in 3ways</h3>
            <ol>
<li> int main () &#123; body &#125; <br /></li>
 <p>This specifies that main will return something this funciton is type of function which return somtehing 
     with no arguments
 </p>
 <li> int main (int argc, char&#123;*arg&#125;[]) &#123; body &#125; <br /></li>
 <ol>
    
     <li><b> argc</b>	-	Non-negative value representing the number of arguments passed to the program from the environment in which the program is run.</li>
     <li><b> argv	</b>-	Pointer to the first element of an array of argc + 1 pointers, of which the last one is null and the previous ones, if any, point to null-terminated multibyte strings that represent the arguments passed to the program from the execution environment.
      If argv[0] is not a null pointer (or, equivalently, if argc &gt; 0), it points to a string that represents the name used to invoke the program, or to an empty string.</li>
 </ol>
 <li> int main (void) &#123;body&#125; <br /></li>
 his specifies that main will not return something this funciton is type of function which no return 
     with arguments
</ol>
        </div>
    )
}

export default Fifteen
